export default "__VITE_ASSET__BxgI6cKX__"